/** As etapas do wizard. A primeira é o vídeo; a última, sempre, o aceite. */
export type WelcomeStep =
  | 'video'
  | 'how-to-buy'
  | 'payment'
  | 'delivery'
  | 'terms';

/** A ordem do wizard. */
export const WELCOME_STEPS: readonly WelcomeStep[] = [
  'video',
  'how-to-buy',
  'payment',
  'delivery',
  'terms',
];

export const WELCOME_TITLES: Record<WelcomeStep, string> = {
  video: 'Veja como funciona',
  'how-to-buy': 'Escolha as peças e monte seu pedido',
  payment: 'Você paga em duas partes',
  delivery: 'Em média 45 dias para entrega',
  terms: 'Antes de começar',
};

/**
 * Eventos do PostHog. Sem PII: só a etapa, o progresso do vídeo e a versão
 * dos termos.
 *
 * O funil é `stepViewed` por etapa; o resto explica as quedas entre uma e
 * outra: quem apertou Voltar, quem pausou o vídeo e onde, quem saiu da conta
 * ou fechou a aba (`abandoned`, com `reason`) e em que ponto do vídeo estava.
 * Toda propriedade de etapa leva `step` e `step_number`. Quem dispara é o
 * `useWelcomeTracking`.
 */
export const WELCOME_EVENT = {
  stepViewed: 'welcome_step_viewed',
  /** `from` → `to` (etapa e número de cada lado). */
  stepAdvanced: 'welcome_step_advanced',
  stepBack: 'welcome_step_back',
  /** `replay` quando é "Assistir de novo", `resume` quando saiu da pausa. */
  videoStarted: 'welcome_video_started',
  /** `progress_pct` de onde parou. */
  videoPaused: 'welcome_video_paused',
  videoCompleted: 'welcome_video_completed',
  /**
   * Desistência: `reason` é `sign_out` (botão Sair) ou `page_closed` (fechou
   * a aba ou recarregou com o wizard aberto). Leva a etapa e, se o vídeo não
   * tinha terminado, `video_progress_pct`.
   */
  abandoned: 'welcome_abandoned',
  termsAccepted: 'terms_accepted',
} as const;

export type AbandonReason = 'sign_out' | 'page_closed';

/**
 * O "Veja como funciona" do cabeçalho: o mesmo vídeo, fora do wizard, para
 * rever a qualquer hora. Família própria para não misturar com o funil de
 * boas-vindas — lá o vídeo é obrigatório, aqui é escolha.
 */
export const HOW_IT_WORKS_EVENT = {
  /** `source`: de onde abriu (`header` ou `mobile_menu`). */
  opened: 'how_it_works_opened',
  videoStarted: 'how_it_works_video_started',
  videoPaused: 'how_it_works_video_paused',
  videoCompleted: 'how_it_works_video_completed',
  /** `completed` e, se não terminou, `video_progress_pct`. */
  closed: 'how_it_works_closed',
} as const;

export type HowItWorksSource = 'header' | 'mobile_menu';

/** As propriedades de etapa que todo evento do wizard carrega. */
export function stepProps(step: WelcomeStep) {
  return { step, step_number: WELCOME_STEPS.indexOf(step) + 1 };
}
